/**
 * Ryan O'Dowd
 * 2023-05-28
 * © Copyright 2023 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, colors, globalScale}) => {
  const bookFontSize = 20;

  return {
    headerPassageAndTranslation: {
      // @TODO: $scale: globalScale,
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: globalScale * 12,
      borderWidth: globalScale * 4,
      margin: 4,
      borderColor: colors.primaryLight,
    },
    bookItem: {
      margin: 8,
      marginTop: 4,
      marginBottom: 4,
    },
    bookText: {
      fontSize: globalScale * bookFontSize,
      color: colors.white,
      fontFamily: fonts.secondaryBold,
    },
    verticalSeparator: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: globalScale * 2,
      height: bookFontSize,
      backgroundColor: colors.primaryLight,
    },
    translationItem: {
      margin: 8,
      marginTop: 4,
      marginBottom: 4,
    },
    translationText: {
      fontSize: globalScale * 14,
      color: colors.white,
    },
  };
};

export default getStyles;
